
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/legal-notice",
      function () {
        return require("private-next-pages/docs/legal-notice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/legal-notice"])
      });
    }
  